import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObjectSchemaRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object-schema',
	path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId',
};
